







































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class Favorite extends Vue {
  selected = false;

  @Prop({
    default: "#61C8F6"
  })
  color: string;

  @Prop({
    default: false
  })
  value: boolean;

  toggleSelected() {
    this.selected = !this.selected;
    this.$emit("input", this.selected);
  }

  created() {
    if (this.value) {
      this.selected = this.value;
    }
  }
}
